export default __webpack_public_path__ + "static/backgroundArchive--blurH-40dd32a938e829f5ceada64db296a830.webp";